export default __webpack_public_path__ + "static/14300-388df672dab2cc23ffdb93d063a942a1.jpg";